import React from 'react';

const WaveForm = ({ id = "waveform", children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        id: id
    }, children);
};

export { WaveForm as default };
